import styled from "styled-components";

export default function OrderDetailTitle() {
  return (
    <Title>주문 상세정보</Title>
  )
}

const Title = styled.h2`
  font-size: calc(100vw * (18 / 375));
  font-weight: 700;
  line-height: calc(100vw * (16 / 375));
  margin-bottom: calc(100vw * (34 / 375));
`;